import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  loading: false,
  report: null,
  todaySalesPerHour: null,
  todayBalance: null,
  tomorrowPayout: null,
  overViewSalesReport: null,
  todayVSYesterdayOverViewSalesReport: null,
  mostSoldProducts: null,
  upsellProducts: null,
  loyaltyProducts: null,
  embedVSApp: null,
  cashUpReport: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
